import React, { Fragment, useState, useEffect } from 'react';
import LaunchIcon from '@material-ui/icons/Launch';
import Tooltip from '@material-ui/core/Tooltip';
import IconButton from '@material-ui/core/IconButton';
import { Field, reduxForm } from 'redux-form';
import { withTranslation } from 'react-i18next';
import { Col, Container, Row, Button } from 'reactstrap'
import { useHistory } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faSquareUpRight } from "@fortawesome/free-solid-svg-icons";

const ListActions = ({ data, state }) => {

    useEffect(() => {
        //console.log(data);
    }, []);

    const history = useHistory();

    const showFeasibility = () => {

        //let _url = "/clinical-studio/confidentiality";//Confidencialidad
        let _url = "/clinical-studio/dashboard";

        history.push({
            pathname: process.env.PUBLIC_URL +_url,
            state: data.original
        });
    }

    return (<Fragment>
        <td role="cell">
            <IconButton onClick={showFeasibility}>
                <FontAwesomeIcon icon={faSquareUpRight} style={{fontSize: '15px' }} />
            </IconButton>
        </td>
    </Fragment>)
}

export default reduxForm({
    form: `modal-form`, // a unique identifier for this form
})(withTranslation('common')(ListActions));